var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(getHomeAirport),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(rootSaga);

import { call, put, all, takeLatest, select } from 'redux-saga/effects';
import get from 'lodash/get';
import fetchNearestAirport from "../api/geo";
import { fetchHomeAirportFailure, fetchHomeAirportSuccess, FETCH_HOME_AIRPORT } from "./ducks";
import { selectIp } from "./selectors";
export function getHomeAirport() {
  var action,
      ip,
      _ref,
      _ref$response,
      response,
      error,
      data,
      _args = arguments;

  return regeneratorRuntime.wrap(function getHomeAirport$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          action = _args.length > 0 && _args[0] !== undefined ? _args[0] : {
            payload: {}
          };
          // Memorized fetch
          ip = action.payload.ip;

          if (ip) {
            _context.next = 6;
            break;
          }

          _context.next = 5;
          return select(selectIp);

        case 5:
          ip = _context.sent;

        case 6:
          _context.prev = 6;
          _context.next = 9;
          return call(fetchNearestAirport, ip);

        case 9:
          _ref = _context.sent;
          _ref$response = _ref.response;
          response = _ref$response === void 0 ? {} : _ref$response;
          error = _ref.error;
          data = response.data;

          if (!(error || !data)) {
            _context.next = 20;
            break;
          }

          _context.next = 17;
          return put(fetchHomeAirportFailure());

        case 17:
          console.error('Failed to load home airport', error);
          _context.next = 22;
          break;

        case 20:
          _context.next = 22;
          return put(fetchHomeAirportSuccess(data));

        case 22:
          _context.next = 29;
          break;

        case 24:
          _context.prev = 24;
          _context.t0 = _context["catch"](6);
          _context.next = 28;
          return put(fetchHomeAirportFailure());

        case 28:
          console.error('Failed to load home airport', _context.t0);

        case 29:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[6, 24]]);
}
export default function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return all([takeLatest(FETCH_HOME_AIRPORT, getHomeAirport)]);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}